var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRenote(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 20,
    viewBox: "0 0 9 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1015_298)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.30053 6.96333V0.103416C1.30053 0.0470072 1.25353 0 1.19712 0H0.103416C0.0470072 0 0 0.0470072 0 0.103416V15.0799C0 15.1489 0.0689439 15.199 0.134754 15.1802L7.29552 12.9395C7.36133 12.9176 7.43027 12.9677 7.43027 13.0398V19.8997C7.43027 19.9561 7.47728 20.0031 7.53369 20.0031H8.62426C8.68066 20.0031 8.72767 19.9561 8.72767 19.8997V4.92009C8.72767 4.85114 8.65873 4.801 8.59292 4.81981L1.43215 7.06048C1.36634 7.08242 1.2974 7.03228 1.2974 6.9602L1.30053 6.96333ZM1.30053 13.3124V8.53964C1.30053 8.49577 1.32874 8.45503 1.37261 8.43936L7.29552 6.58414C7.36133 6.56221 7.43027 6.61235 7.43027 6.68442V11.4572C7.43027 11.5011 7.40207 11.5418 7.35819 11.5575L1.43529 13.4127C1.36948 13.4347 1.30053 13.3845 1.30053 13.3124Z",
    fill: "#4A4A4A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1015_298"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.72767,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRenote);
export default __webpack_public_path__ + "static/media/renote.927b2a1c0fa983b92d738b9a4fcee349.svg";
export { ForwardRef as ReactComponent };